(function ($) {
    $('.js-resources-filter-form').one('submit', function(e) {
        e.preventDefault();
        $form = $(this);
        $form.find('select, input').each(function() {
            if ($(this).val() === '') {
                $(this).attr('disabled', true);
            }
        });
        $form.submit();
    });
})(jQuery);
